export default "__VITE_ASSET__B584xI81__"